module.exports = __webpack_public_path__ + "static/img/ProximaNovaA-Bold.a59d10c3.svg";